import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const FrontCanvas = React.memo((props) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    if (props.staticTemplate == null) {
        return null;
    }

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    let pagesContainer = null;
    if (numPages != null) {
        pagesContainer = <p>Page {pageNumber} of {numPages}</p>;
    }

    const handleNextPage = () => {
        if (parseInt(pageNumber) < numPages) {
            setPageNumber(pageNumber + 1);
        }
    };

    const handlePrevPage = () => {
        if (parseInt(pageNumber) > 1) {
            setPageNumber(pageNumber - 1);
        }
    };

    let prevButtonClasses = ['prev-button'];
    if (parseInt(pageNumber) === 1) {
        prevButtonClasses.push('disabled');
    }

    let nextButtonClasses = ['next-button'];
    if (parseInt(pageNumber) === numPages) {
        nextButtonClasses.push('disabled');
    }

    let covidPosterContainer = null;
    let pdfPreview = null;
    let controlsContainer = null;

    if (parseInt(props.templateCode) === 473) {
        covidPosterContainer = (
            <div>
                <div className="portrait">Portrait: 24" x 36"</div>
                <div className="portrait-preview-image">
                    <img src="https://ac-ut-health.s3.amazonaws.com/static-preview-images/UTP-Portrait-Poster-English-Portrait.jpg" alt="COVID Poster" />
                </div>
                <hr />
                <div className="landscape">Landscape: 36" x 24" | 24" x 18" | 18" x 18"</div>
                <div className="landscape-preview-image">
                    <img src="https://ac-ut-health.s3.amazonaws.com/static-preview-images/UTP-Portrait-Poster-English-Landscape.jpg" alt="COVID Poster" />
                </div>
            </div>
        );
    } else if (parseInt(props.templateCode) === 647) {
        let title = '';
        if (props.type === 'Framed Poster') {
            title = 'Patient Code of Conduct to Display in Lobbies Only';
        } else if (props.type === 'Static Cling Poster') {
            title = 'Patient Code of Conduct to Display on Back of Exam Rooms Doors Only';
        }

        if (props.language === 'English') {
            covidPosterContainer = (
                <div>
                    <div className="portrait mb-3">{title}</div>
                    <div className="patient-code-conduct-image">
                        <img src="https://ac-ut-health.s3.amazonaws.com/static-preview-images/patient-code-of-conduct-english.png" alt="Patient code of conduct" />
                    </div>
                </div>
            );
        } else if (props.language === 'Spanish') {
            covidPosterContainer = (
                <div>
                    <div className="portrait mb-3">{title}</div>
                    <div className="patient-code-conduct-image">
                        <img src="https://ac-ut-health.s3.amazonaws.com/static-preview-images/patient-code-of-conduct-spanish.png" alt="Patient code of conduct" />
                    </div>
                </div>
            );
        }
    } else if (parseInt(props.templateCode) === 648) {
        let pdfUrl = null;

        if (props.language === 'English') {
            if (props.printingOption === 'color') {
                pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/static-files/permission_for_verbal_communication_utp-103_(02-24)_proof_VF-color.pdf';
            } else {
                pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/static-files/permission_for_verbal_communication_utp-103_(02-24)_proof_VF-BW.pdf';
            }
        } else {
            if (props.printingOption === 'color') {
                pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/static-files/permission_for_verbal_communication_utp-103_(02-24)_proof_VF_ES-US-color.pdf';
            } else {
                pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/static-files/permission_for_verbal_communication_utp-103_(02-24)_proof_VF_ES-US-BW.pdf';
            }
        }

        if (pdfUrl != null) {
            pdfPreview = (
                <div className="pdf-preview">
                    <Document
                        file={pdfUrl}
                        onLoadSuccess={onDocumentLoadSuccess}
                    >
                        <Page width="555" pageNumber={pageNumber} renderAnnotationLayer={false} />
                    </Document>
                    {pagesContainer}
                </div>
            );
        }
    } else if (parseInt(props.templateCode) === 649) {
        let pdfUrl = null;

        if (props.language === 'English') {
            pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/static-files/Infective-Endocarditis-Wallet-Card-English.pdf';
        } else {
            pdfUrl = 'https://ac-ut-health.s3.amazonaws.com/static-files/Infective-Endocarditis-Wallet-Card-Spanish.pdf';
        }

        if (pdfUrl != null) {
            controlsContainer = (
                <h5>
                    <div className={prevButtonClasses.join(' ')} onClick={handlePrevPage}>
                        <i className="fas fa-chevron-left" /> Prev
                    </div>
                    <div className="title">Preview</div>
                    <div className={nextButtonClasses.join(' ')} onClick={handleNextPage}>
                        Next <i className="fas fa-chevron-right" />
                    </div>
                </h5>
            );
            
            pdfPreview = (
                <div className="pdf-preview">
                    <Document
                        file={pdfUrl}
                        onLoadSuccess={onDocumentLoadSuccess}
                    >
                        <Page width="555" pageNumber={pageNumber} renderAnnotationLayer={false} />
                    </Document>
                    {pagesContainer}
                </div>
            );
        }
    } else if (parseInt(props.templateCode) === 650) {
        pdfPreview = (
            <div>
                <div className="portrait">Side 1</div>
                <div>
                    <img style={{width: '100%'}} src="https://ac-ut-health.s3.amazonaws.com/static-images/utpm24-237-pediatrics-surgery_card-side_1.jpg" alt="Form" />
                </div>
                <hr />
                <div className="landscape">Side 2</div>
                <div>
                    <img style={{width: '100%'}} src="https://ac-ut-health.s3.amazonaws.com/static-images/utpm24-237-pediatrics-surgery_card-side_2.jpg" alt="Form" />
                </div>
            </div>
        );
    } else if (parseInt(props.templateCode) === 651) {
        controlsContainer = (
            <h5>
                <div className="title">Preview</div>
            </h5>
        );

        if (props.language === 'English' && props.type === 'Pass') {
            pdfPreview = (
                <div>
                    <img 
                        style={{width: '100%'}} 
                        src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-preview-images/English_Newborn_Screenings_PASS_Flyer.jpg" 
                        alt="Form" 
                    />
                </div>
            );
        } else if (props.language === 'Spanish' && props.type === 'Pass') {
            pdfPreview = (
                <div>
                    <img 
                        style={{width: '100%'}} 
                        src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-preview-images/Spanish_Newborn_Screenings_PASS_Flyer_Print.jpg" 
                        alt="Form" 
                    />
                </div>
            );
        } else if (props.language === 'English' && props.type === 'Did Not Pass') {
            pdfPreview = (
                <div>
                    <div className="portrait">Front</div>
                    <div>
                        <img 
                            style={{width: '100%'}} 
                            src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-preview-images/English_Newborn_Screenings_DID_NOT_PASS_Flyer-English_Front.jpg" 
                            alt="Form" 
                        />
                    </div>
                    <hr />
                    <div className="landscape">Back</div>
                    <div>
                        <img 
                            style={{width: '100%'}} 
                            src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-preview-images/English_Newborn_Screenings_DID_NOT_PASS_Flyer-English_Back.jpg" 
                            alt="Form" 
                        />
                    </div>
                </div>
            );
        } else  if (props.language === 'Spanish' && props.type === 'Did Not Pass') {
            pdfPreview = (
                <div>
                    <div className="portrait">Front</div>
                    <div>
                        <img 
                            style={{width: '100%'}} 
                            src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-preview-images/Spanish_Newborn_Screenings_DID_NOT_PASS_Flyer_Front.jpg" 
                            alt="Form" 
                        />
                    </div>
                    <hr />
                    <div className="landscape">Back</div>
                    <div>
                        <img 
                            style={{width: '100%'}} 
                            src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-preview-images/Spanish_Newborn_Screenings_DID_NOT_PASS_Flyer_Print_Back.jpg" 
                            alt="Form" 
                        />
                    </div>
                </div>
            );
        }
    } else if (parseInt(props.templateCode) === 652) {
        controlsContainer = (
            <h5>
                <div className="title">Preview</div>
            </h5>
        );

        pdfPreview = (
            <div>
                <div className="portrait">Front</div>
                <div>
                    <img 
                        style={{width: '100%'}} 
                        src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-preview-images/utpm24-450-orl-hearing-aid-flyer-front.png" 
                        alt="Form" 
                    />
                </div>
                <hr />
                <div className="landscape">Back</div>
                <div>
                    <img 
                        style={{width: '100%'}} 
                        src="https://ac-ut-health.s3.us-east-1.amazonaws.com/static-preview-images/utpm24-450-orl-hearing-aid-flyer-back.png" 
                        alt="Form" 
                    />
                </div>
            </div>
        );
    } else {
        controlsContainer = (
            <h5>
                <div className={prevButtonClasses.join(' ')} onClick={handlePrevPage}>
                    <i className="fas fa-chevron-left" /> Prev
                </div>
                <div className="title">Preview</div>
                <div className={nextButtonClasses.join(' ')} onClick={handleNextPage}>
                    Next <i className="fas fa-chevron-right" />
                </div>
            </h5>
        );
        pdfPreview = (
            <div className="pdf-preview">
                <Document
                    file={props.staticTemplate.file_url}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    <Page width="555" pageNumber={pageNumber} renderAnnotationLayer={false} />
                </Document>
                {pagesContainer}
            </div>
        );
    }

    return (
        <div className="front-canvas-container">
            {controlsContainer}
            {covidPosterContainer}
            {pdfPreview}
        </div>
    );
});

FrontCanvas.propTypes = {

}

export default FrontCanvas;
